import type { SVGProps } from "react";

/**
 * Chop / dice — chef's knife angled above a cutting board.
 */
export function ChopIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* Cutting board */}
      <rect
        x={6}
        y={28}
        width={36}
        height={4}
        rx={1}
        fill="currentColor"
        opacity={0.25}
      />
      <rect
        x={8}
        y={32}
        width={32}
        height={3}
        rx={1}
        fill="currentColor"
        opacity={0.15}
      />
      {/* Knife blade */}
      <path d="m24 6-12 22h24L24 6Z" fill="currentColor" opacity={0.85} />
      {/* Knife handle */}
      <rect
        x={18}
        y={2}
        width={12}
        height={5}
        rx={2}
        fill="currentColor"
        opacity={0.6}
      />
    </svg>
  );
}
